__turbopack_context__.v({
  "aside": "Showreel-module-scss-module__iuhO6W__aside",
  "band": "Showreel-module-scss-module__iuhO6W__band",
  "glyph": "Showreel-module-scss-module__iuhO6W__glyph",
  "grid": "Showreel-module-scss-module__iuhO6W__grid",
  "poster": "Showreel-module-scss-module__iuhO6W__poster",
  "reel": "Showreel-module-scss-module__iuhO6W__reel",
  "toggle": "Showreel-module-scss-module__iuhO6W__toggle",
  "video": "Showreel-module-scss-module__iuhO6W__video",
});
